/**
 * Scrollbar styling for a dropdown's scrolling option list — apply it to whichever element actually
 * scrolls (the inner list container in `BasicDropdown`, the anchored panel itself in the Combobox
 * dropdowns, where Headless UI sets `overflow: auto` inline).
 *
 * `globals.css` already styles scrollbars app-wide, but only half of what a dropdown needs:
 *
 * - it targets `::-webkit-scrollbar`, which Firefox ignores outright — leaving Firefox to render its
 *   unstyled ~15px scrollbar;
 * - its thumb is `rgba(255, 255, 255, .2)`, right for the app's dark surfaces and invisible on a
 *   dropdown panel, which is `bg-white`.
 *
 * That matters more than scrollbar styling usually would. A space-taking scrollbar narrows the
 * option rows' content box, so every row's hover highlight stops short of the panel's right edge —
 * which reads as a gap in the panel rather than as a scrollbar, in both browsers (Firefox merely
 * makes it wide enough to notice).
 *
 * Content can never extend under a space-taking scrollbar, so this makes the strip narrow and
 * visibly a scrollbar rather than trying to reclaim it.
 *
 * `rgb(0 0 35 / 0.2)` is `darkBlue` (#000023) at 20%, spelled out because Tailwind's
 * arbitrary-property syntax cannot resolve a theme colour.
 */
export const DROPDOWN_SCROLLBAR_CLASSNAME =
    '[scrollbar-width:thin] [scrollbar-color:rgb(0_0_35_/_0.2)_transparent] [&::-webkit-scrollbar-thumb]:bg-darkBlue/20';
